import axios from 'axios'
import { dataTrim } from '@/util/dataTrim'

axios.defaults.timeout = 1200000;
axios.defaults.withCredentials = false;

//整理数据
axios.defaults.transformRequest = function (data) {

  return data;
};

//http request 拦截器
axios.interceptors.request.use(
  config => {
    // 方式浏览器缓存
    if(isUat){
        console.log("进入UAT环境，需要对请求地址进行强制uat转换！")
        if (config.url.indexOf('uat') < 0) {
            config.url = config.url.replace("/govp", "/uat/govp");
        }
    }

    if(config.url.indexOf('?')>-1){
      config.url=config.url+"&radom="+Math.random();
    }else{
      config.url=config.url+"?radom="+Math.random();
    }
    let token = localStorage.getItem("token");
    if (token) { // 判断是否存在token，如果存在的话，则每个http header都加上token
      config.headers.token = token;
      config.headers.Authorization = token;
    }
    config.data = config.data && dataTrim(config.data)
    config.params = config.params && dataTrim(config.params)
    if (config.data && config.data.contentType && config.data.contentType == 1) {

      let params = new URLSearchParams();
      if (config.data) {
        var map = config.data
        for (var key in map) {
          if (key != 'contentType') {
            params.append(key, map[key]);
          }
        }
      }
      config.data = params
      config.headers['Content-Type'] = 'application/x-www-form-urlencoded';
    } else {
      // 具有分页参数的列表接口，因为之前分页参数在系统中不统一，在请求拦截中对分页参数进行补全，大小写的参数都放在参数里，防止后端接口取不到准确分页参数的情况。 -- start
      if(config.data && config.data.hasOwnProperty("PAGE")) {
        config.data.page = config.data.PAGE;
        config.data.pageSize = config.data.PAGESIZE;
      } else if(config.data && config.data.hasOwnProperty("page")) {
        config.data.PAGE = config.data.page;
        config.data.PAGESIZE = config.data.pageSize;
      }
      // ---- end
      config.data = JSON.stringify(config.data);
      config.headers['Content-Type'] = 'application/json;charset=UTF-8';
    }
    return config;
  },
  error => {
    return Promise.reject(err);
  }
);

//响应拦截器即异常处理


// 新增校验Post方法 url:请求URL ,data 请求数据集，config配置信息，ids校验的id集合，noCheckTypes[]放过的异常类型数组集合
axios.checkPost = function (url, data, config, ids, noCheckTypes) {

  let res = null;
  let promise = new Promise((resolve, reject) => {//使用Promise（承诺）来将异步控制成同步请求
    if (Array.isArray(ids)) {//如果是数组走校验标包的方式
      res = axios.checkBidPackages(ids, noCheckTypes);
    } else {//否则走校验项目的方法
      res = axios.checkProject(ids);
    }
    res.then((result) => {
      if (result && result.status == 200) {
        let resData = result.data;
        if (resData.success) {//如果后台项目校验通过，则继续执行后续方法
          let obj = axios.post(url, data, config);
          resolve(obj);
        } else { //否则后续方法不执行
          reject(resData.msg || resData);
        }
      } else {
        reject(result);
      }
    })
  })
  return promise;
}

//新增校验Get方法url:请求URL ,data 请求数据集，config配置信息，ids校验的id集合，noCheckTypes[]放过的异常类型数组集合
axios.checkGet = function (url, data, config, ids, noCheckTypes) {
  let res = null;
  let promise = new Promise((resolve, reject) => {//使用Promise（承诺）来将异步控制成同步请求
    if (Array.isArray(ids)) {//如果是数组走校验标包的方式
      res = axios.checkBidPackages(ids, noCheckTypes);
    } else {//否则走校验项目的方法
      res = axios.checkProject(ids);
    }
    res.then((result) => {
      if (result && result.status == 200) {
        let resData = result.data;
        if (resData.success) {//如果后台项目校验通过，则继续执行后续方法
          let obj = axios.get(url, data, config);
          resolve(obj);
        } else { //否则后续方法不执行
          reject(resData.msg || resData);
        }
      } else {
        reject(result);
      }
    })
  })
  return promise;
}

// 校验项目是否异常
axios.checkProject = async function (projectId) {
  let param = Object.assign({}, {
    projectId: projectId,
  });
  return await axios.get(process.env.API_HOST + "gp-exception/checkProject", { params: param });
}
// 校验选中项目是否异常
axios.checkBidPackages = async function (ids, noCheckTypes) {
  return await axios.post(process.env.API_HOST + "gp-exception/checkBidPackages", { bidPackageIds: ids, types: noCheckTypes });
}
export default axios;



// WEBPACK FOOTER //
// ./src/axios/ajax.js